import QuranApp from '../../../assets/Images/About/AlQuranProject.png'

export const PortfolioImg = [
    {
        id: 1,
        image: QuranApp,
        category: "FullStack",
        description: "Solo Project: Al Quran App designed for users who are engaged in memorizing the Holy Quran,offering the ability to create and track plans,listen to chapter audio, and memorize chapters of verses with ease.The app also maintains weekly plans and sends notification for chapters surpassing their deadlines.",
        github:"https://github.com/ZakariyeAden/Quran-App"
    },
 
]